import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { authGuard, permissionGuard } from './guards'
import { env } from '@/core/config/env'

const router = createRouter({
  history: createWebHistory(env.baseUrl),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

router.beforeEach(authGuard)
router.beforeEach(permissionGuard)

router.afterEach((to) => {
  const title = to.meta.title as string | undefined
  document.title = title ? `${title} | Toteat Backoffice` : 'Toteat Backoffice'
})

export default router
